// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { nextFriday as fn } from "../nextFriday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const nextFriday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default nextFriday;
